import createEntityChangementConfig2 from '@infrastructure/entityChangement/createEntityChangementConfig2'
import queryClient from '@infrastructure/reactQuery/queryClient'
import { invalidateQueryKeys } from '@infrastructure/reactQuery/utils'

import articleRQKeys from '../reactQuery/articleRQKeys'
import articleHelpers from '../service/articleHelpers'

export default createEntityChangementConfig2({
  entity: articleHelpers.entityName,
  config: [
    {
      changements: ['created', 'updated', 'deleted'],
      listener: () => {
        const keys = [articleRQKeys.lists()]
        invalidateQueryKeys(keys, queryClient)
      }
    },
    {
      changements: ['updated'],
      listener: ({ meta: { id } }) => {
        const key = articleRQKeys.detail(id)
        queryClient.invalidateQueries(key)
      }
    },
    {
      changements: ['deleted'],
      listener: ({ meta: { id } }) => {
        const key = articleRQKeys.detail(id)
        queryClient.removeQueries(key)
      }
    }
  ]
})
